module.exports = __webpack_public_path__ + "img/site_type_img_11.4e156f41.png";